import {
  Component,
  Input,
  HostBinding
} from '@angular/core';

export type BadgeType = 'default' | 'info' | 'success' | 'attention' | 'alert' | 'disabled';

@Component({
  selector: 'suka-badge',
  template: `<ng-content></ng-content>`
})
export class Badge {
  /**
   * Badge type. Defaults to `default`.
   */
  @Input() type: BadgeType = 'default';

  /**
   * Badge size. Defaults to `md`.
   */
  @Input() size: 'sm' | 'md' = 'md';

  @Input() class = '';

  @HostBinding('attr.class') get attrClass() {
    return `badge badge--${this.type} badge--${this.size} ${this.class}`;
  }
}
